module.exports = __webpack_public_path__ + "img/content4.fd685a23.png";